// register vue composition api globally
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@vueuse/head';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import Home from '@/components/Home.vue';
import Callback from '@/components/Callback.vue';
import SilentCallback from '@/components/SilentCallback.vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { datadogLogs } from '@datadog/browser-logs';

import './styles/main.scss';

// windicss layers
import 'virtual:windi.css';
import 'virtual:windi-devtools';

// Vuetify
import { registerPlugins } from '@/plugins';

// Create app
const app = createApp(App);

// Set up website head
const head = createHead();

// datadog error tracking
if (process.env.NODE_ENV !== 'development') {
  datadogLogs.init({
    clientToken: 'pubb2545a8be1ad360cabca3f5c8049b332',
    site: 'datadoghq.com',
    service: 'banjo',
    env: process.env.NODE_ENV,
    version: '1.0.0',
    forwardConsoleLogs: ['error', 'debug'],
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });
}

// Set up router
const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/callback', name: 'Callback', component: Callback },
  { path: '/silent-renew-callback', name: 'SilentCallback', component: SilentCallback },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const pinia = createPinia();

// Use all required modules
app.use(pinia).use(head).use(router);
app.use(Toast, {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
});
registerPlugins(app);

// Mount app
app.mount('#sis-football-data-collection');
